import { gql } from '@at/sauron-platform-graphql'

export const SAVED_SEARCHES_QUERY = gql`
    query SavedSearchesQuery($channel: VehicleChannel) {
        user {
            databaseId
            savedSearches(channel: $channel) {
                results {
                    id
                    name
                    canonicalSearchValues
                    searchCriteria
                }
            }
            email
            userTokenValidated
        }
    }
`
export const ADD_SAVED_SEARCH = gql`
    mutation AddSavedSearch($savedSearchInput: SavedSearchInput!) {
        addSavedSearch(savedSearchInput: $savedSearchInput) {
            id
            name
            alert
            canonicalSearchValues
        }
    }
`
